import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { makeStyles } from '@mui/styles';
import helpers from 'src/styles/helpers';
import sections from 'src/styles/sections';
import { palette } from '@livable/saas-react-components';
const useStyles = makeStyles(_objectSpread(_objectSpread(_objectSpread({}, helpers), sections), {}, {
  pageWrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minHeight: 0,
    paddingTop: '12px',
    backgroundColor: palette.shades[100],
    borderTop: "1px solid ".concat(palette.shades[300])
  },
  pageHeader: {
    flexShrink: 0,
    padding: '4px 16px 12px'
  },
  headerWrapper: {
    flexShrink: 0,
    borderBottom: "1px solid ".concat(palette.shades[300])
  },
  headerTabs: {
    padding: '0 12px'
    // borderBottom: `1px solid ${palette.shades[300]}`,
  },
  headerFilters: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '65px'
  },
  contentWrapper: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    // Inset the banner and the dashboard from the page edges so neither runs full-bleed (LB-5820).
    padding: '8px 16px 16px'
  },
  // Bills tab: full height, scroll inside table. Framed as a contained panel so the dashboard reads
  // as a distinct, prominent section rather than loose full-bleed content (LB-5820).
  billsRoot: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    backgroundColor: '#FFFFFF',
    border: "1px solid ".concat(palette.shades[300]),
    borderRadius: 8,
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.06)'
  },
  '@keyframes billsRefreshSpin': {
    from: {
      transform: 'rotate(0deg)'
    },
    to: {
      transform: 'rotate(360deg)'
    }
  },
  /**
   * Refresh sits beside Filters in the left group and is drawn as a primary-coloured button rather
   * than a quiet icon, so the reload affordance is easy to find. Fills solid on hover (LB-5820).
   */
  billsRefreshButton: {
    '&.MuiButton-root': {
      flexShrink: 0,
      alignSelf: 'stretch',
      minHeight: 36,
      padding: '0 12px',
      fontSize: 13,
      fontWeight: 600,
      lineHeight: '16px',
      color: palette.primary.main,
      backgroundColor: palette.shades[100],
      border: "1px solid ".concat(palette.primary.main),
      boxShadow: 'none',
      '& .MuiButton-startIcon': {
        marginLeft: 0,
        marginRight: 8
      },
      '& .MuiSvgIcon-root': {
        width: 20,
        height: 20
      },
      '&:hover': {
        backgroundColor: palette.primary.main,
        color: palette.common.white,
        borderColor: palette.primary.main,
        boxShadow: 'none'
      }
    },
    // Beat the toolbar's white-icon rule (meant for the contained buttons) so the reload glyph reads
    // in the primary colour; it turns white on hover once the background fills.
    '&&& path': {
      fill: palette.primary.main
    },
    '&&&:hover path': {
      fill: palette.common.white
    },
    '&.Mui-disabled': {
      opacity: 0.5
    }
  },
  billsRefreshButtonSpinning: {
    '& svg': {
      animation: '$billsRefreshSpin 0.8s linear infinite'
    }
  },
  billsToolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 16,
    padding: '16px',
    flexShrink: 0,
    borderBottom: "1px solid ".concat(palette.shades[300]),
    '& .MuiTextField-root': {
      minWidth: 320
    },
    /**
     * One height for everything on the strip. The search field, the three selects and the buttons
     * each have their own natural height, and left alone they sit at four slightly different sizes
     * along the same line.
     */
    '& .MuiButton-root': {
      height: 40
    },
    '& .MuiOutlinedInput-root': {
      height: 40
    },
    '& .MuiButton-root path': {
      fill: palette.shades[100]
    },
    '& > div:first-of-type > div > div:first-of-type': {
      top: 5,
      left: 8
    },
    '& .MuiChip-root': {
      padding: '8px',
      '& svg': {
        marginRight: '4px'
      }
    }
  },
  billsToolbarLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    flex: 1,
    minWidth: 0
  },
  /**
   * The status pill, drawn the same way as the one in the upload modal so a bill looks the same
   * wherever its state is shown. Dot in the saturated shade, label in the darker one.
   */
  billsStatusChip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    padding: '3px 10px',
    borderRadius: 4,
    fontSize: 12,
    lineHeight: '18px',
    fontWeight: 600,
    whiteSpace: 'nowrap'
  },
  billsStatusDot: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    flexShrink: 0
  },
  billsStatus_neutral: {
    backgroundColor: palette.shades[200],
    color: palette.shades[800],
    '& $billsStatusDot': {
      backgroundColor: palette.shades[600]
    }
  },
  billsStatus_info: {
    backgroundColor: palette.info.light,
    color: palette.info.dark,
    '& $billsStatusDot': {
      backgroundColor: palette.info.main
    }
  },
  billsStatus_success: {
    backgroundColor: palette.success.light,
    color: palette.success.dark,
    '& $billsStatusDot': {
      backgroundColor: palette.success.main
    }
  },
  billsStatus_warning: {
    backgroundColor: palette.warning.light,
    color: palette.warning.dark,
    '& $billsStatusDot': {
      backgroundColor: palette.warning.main
    }
  },
  billsStatus_error: {
    backgroundColor: palette.error.light,
    color: palette.error.dark,
    '& $billsStatusDot': {
      backgroundColor: palette.error.main
    }
  },
  /** The prompt on a bill nobody has placed. Reads as an invitation rather than as missing data. */
  billsUnmatchedProperty: {
    color: palette.primary.main
  },
  /** An address is the sender, not a label, so it is set apart from the channel names beside it. */
  billsSenderEmail: {
    color: palette.primary.main
  },
  billsToolbarRight: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    flexShrink: 0
  },
  billsTabs: {
    marginBottom: 16,
    // Same inset as the cards and the toolbar, so the whole left edge of the page reads as one line.
    padding: '0 16px',
    minHeight: 40,
    '& .MuiTab-root': {
      minHeight: 40,
      textTransform: 'none'
    }
  },
  billsTabLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8
  },
  /**
   * The count rides beside the name rather than in brackets after it, so the number reads as a
   * quantity of work and not as part of the tab's title.
   */
  billsTabCount: {
    minWidth: 20,
    padding: '0 6px',
    borderRadius: 10,
    fontSize: 11,
    lineHeight: '18px',
    backgroundColor: palette.shades[200],
    color: palette.shades[800]
  },
  billsTabCountActive: {
    backgroundColor: palette.primary.main,
    color: palette.common.white
  },
  billsTablePaper: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    overflow: 'hidden',
    boxShadow: 'none',
    border: 'none',
    borderRadius: 0,
    '& .MuiTableCell-root': {
      fontSize: 14,
      verticalAlign: 'top'
    },
    '& .MuiTableRow-root .MuiTableCell-root:first-of-type': {
      paddingLeft: 4,
      paddingRight: 4
    },
    '& .MuiTableHead-root .MuiTableCell-root:first-of-type': {
      paddingTop: 8
    },
    '& .MuiTableBody-root .MuiTableCell-root:first-of-type': {
      paddingTop: 10
    }
  },
  billsTableContainer: {
    flex: 1,
    overflow: 'auto',
    minHeight: 0,
    WebkitOverflowScrolling: 'touch'
  },
  billsTable: {
    minWidth: 2040
  },
  billsFileNameCell: {
    minWidth: 200,
    maxWidth: 260
  },
  billsFileNameRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    minWidth: 0,
    overflow: 'hidden'
  },
  /** th/td: force single-line cell content (Typography noWrap alone is not enough in tables) */
  billsCellNoWrap: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    wordBreak: 'normal',
    overflowWrap: 'normal',
    verticalAlign: 'middle'
  },
  billsUtilitiesCell: {
    whiteSpace: 'nowrap'
  },
  billsUtilitiesIcons: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    flexWrap: 'nowrap',
    '& svg': {
      display: 'block',
      flexShrink: 0
    }
  },
  billsPropertiesCell: {
    minWidth: 220,
    maxWidth: 320
  },
  billsTableChip: {
    fontSize: 13,
    maxWidth: '100%',
    '& .MuiChip-label': {
      fontSize: 13,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  },
  billsStickyCheckboxHead: {
    position: 'sticky',
    left: 0,
    zIndex: 5,
    backgroundColor: '#FFFFFF',
    boxShadow: 'none',
    borderRight: "1px solid ".concat(palette.shades[300])
  },
  billsStickyCheckbox: {
    position: 'sticky',
    left: 0,
    zIndex: 1,
    backgroundColor: '#FFFFFF',
    boxShadow: 'none',
    borderRight: "1px solid ".concat(palette.shades[300])
  },
  billsStickyActionsHead: {
    position: 'sticky',
    right: 0,
    zIndex: 5,
    backgroundColor: '#FFFFFF',
    boxShadow: 'none',
    borderLeft: "1px solid ".concat(palette.shades[300])
  },
  billsStickyActions: {
    position: 'sticky',
    right: 0,
    zIndex: 1,
    backgroundColor: '#FFFFFF',
    boxShadow: 'none',
    borderLeft: "1px solid ".concat(palette.shades[300])
  },
  billsTableEmpty: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  tableHeadCell: {
    fontWeight: 600,
    backgroundColor: '#FFFFFF',
    borderBottom: "1px solid ".concat(palette.shades[300]),
    whiteSpace: 'nowrap'
  },
  tableBodyRow: {
    '& .MuiTableCell-root': {
      borderBottom: "1px solid ".concat(palette.shades[300])
    },
    /**
     * The last row keeps its rule too. Without this the table stops on an open edge and the final
     * bill looks like it is still being written; the higher-specificity selector is there to beat
     * whatever strips it by default.
     */
    '&:last-child .MuiTableCell-root': {
      borderBottom: "1px solid ".concat(palette.shades[300])
    }
  },
  billsClickableRow: {
    cursor: 'pointer'
  },
  pricingsCell: {
    verticalAlign: 'top',
    paddingTop: 8,
    paddingBottom: 8
  },
  pricingsStack: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    paddingRight: '24px'
  },
  pricingCard: {
    border: "1px solid ".concat(palette.shades[300]),
    borderRadius: 2,
    padding: '8px 10px',
    backgroundColor: '#f8f9fa'
  },
  pricingCardContent: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 8
  },
  pricingAmount: {
    whiteSpace: 'nowrap',
    marginLeft: 'auto'
  },
  actionsCell: {
    verticalAlign: 'top',
    paddingTop: 8,
    paddingBottom: 8,
    minWidth: 68,
    width: 68,
    whiteSpace: 'nowrap'
  },
  /**
   * One strip along the bottom of the table: what is selected and what can be done with it on the
   * left, paging on the right. The border lives here rather than on the pagination so the rule runs
   * the full width whether or not anything is selected.
   */
  billsFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
    flexShrink: 0,
    minHeight: 52,
    paddingLeft: 8,
    borderTop: "1px solid ".concat(palette.shades[300])
  },
  billsFooterActions: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    minWidth: 0,
    flexWrap: 'wrap'
  },
  /** The count is the part that changes, so it carries the weight and the words around it do not. */
  billsFooterCount: {
    fontWeight: 600
  },
  billsFooterSeparator: {
    color: palette.shades[500]
  },
  tablePagination: {
    flexShrink: 0
  },
  // Pricings tab: select all bar and scroll area
  pricingsSelectAllBar: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '4px 10px',
    borderBottom: "1px solid ".concat(palette.shades[300]),
    backgroundColor: '#fff',
    flexShrink: 0
  },
  pricingsSelectAllCheckbox: {
    padding: 4
  },
  pricingsSelectAllLabel: {
    userSelect: 'none'
  },
  pricingsScrollWrapper: {
    flex: 1,
    minHeight: 0,
    overflow: 'auto'
  },
  pricingsEmpty: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  pricingsRecord: {
    borderBottom: "1px solid ".concat(palette.shades[300]),
    '&:last-child': {
      borderBottom: 'none'
    }
  },
  pricingsRecordHeader: {
    position: 'sticky',
    top: 0,
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 0,
    backgroundColor: '#f3f7fa',
    borderBottom: "1px solid ".concat(palette.shades[300]),
    padding: '12px 16px',
    fontWeight: 600,
    fontSize: 15,
    justifyContent: 'space-between'
  },
  pricingsRecordHeaderLeft: {
    display: 'flex',
    alignItems: 'center'
  },
  pricingsRecordHeaderRight: {
    display: 'flex',
    alignItems: 'center'
  },
  pricingsRecordHeaderExpand: {
    padding: 4,
    marginRight: 4
  },
  pricingsRecordHeaderTitle: {
    marginRight: 8
  },
  pricingsRecordHeaderDivider: {
    width: 1,
    height: 20,
    backgroundColor: palette.shades[300],
    margin: '0 12px',
    flexShrink: 0
  },
  pricingsRecordHeaderCount: {
    fontWeight: 500,
    fontSize: 14,
    color: palette.shades[700]
  },
  pricingsRecordHeaderAdd: {
    marginLeft: 0,
    padding: 4
  },
  pricingsRecordContent: {
    padding: 0,
    backgroundColor: '#FFFFFF'
  },
  pricingsContentRow: {
    display: 'flex',
    alignItems: 'stretch',
    padding: '4px 10px',
    borderBottom: "1px solid ".concat(palette.shades[300]),
    gap: 12,
    '&:last-child': {
      borderBottom: 'none'
    }
  },
  pricingsContentRowCheckbox: {
    padding: 4,
    flexShrink: 0,
    alignSelf: 'center'
  },
  pricingsContentRowName: {
    minWidth: 0,
    alignSelf: 'center'
  },
  pricingsContentRowChip: {
    flexShrink: 0,
    alignSelf: 'center',
    fontSize: 11,
    height: 20,
    '& .MuiChip-label': {
      fontSize: 12
    }
  },
  pricingsContentRowSubs: {
    flexShrink: 0,
    alignSelf: 'center'
  },
  pricingsContentRowDivider: {
    width: 1,
    height: 20,
    backgroundColor: palette.shades[300],
    margin: '0 2px',
    flexShrink: 0,
    alignSelf: 'center'
  },
  pricingsContentRowSpacer: {
    flex: '1 1 auto',
    minWidth: 0
  },
  pricingsContentRowPrices: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    gap: 0,
    flexShrink: 0,
    marginRight: 8,
    alignSelf: 'stretch'
  },
  pricingsPriceBlock: {
    minWidth: 70,
    marginLeft: -1,
    padding: '8px 10px',
    backgroundColor: 'transparent',
    border: 'none',
    borderLeft: "1px solid ".concat(palette.shades[300]),
    borderRight: "1px solid ".concat(palette.shades[300]),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: 4
  },
  pricingsPriceBlockTitle: {
    fontSize: 12,
    lineHeight: 1.2
  },
  pricingsPriceBlockAmount: {
    fontSize: 14,
    lineHeight: 1.2
  },
  pricingsContentRowActions: {
    display: 'flex',
    alignItems: 'center',
    gap: 0,
    flexShrink: 0,
    alignSelf: 'center',
    '& .MuiIconButton-root': {
      padding: 4
    },
    '& svg': {
      padding: 2
    }
  },
  pricingsDeleteButtonDefault: {
    opacity: 0.5
  },
  bulkDeleteConfirmBody: {
    padding: 24
  },
  bulkDeleteConfirmTitle: {
    marginBottom: 8
  }
}));
export default useStyles;